export default defineNuxtPlugin(async () => {
  const { fetchMe, loaded } = useAuth()
  if (!loaded.value) await fetchMe()
})
